import { useEffect, useState } from "react";

/**
 * Responsive helper — same shape as the RN version, but powered by
 * window.innerWidth / matchMedia instead of react-native useWindowDimensions.
 */
const MOBILE_MAX = 767;
const TABLET_MAX = 1023;

function getDims() {
  if (typeof window === "undefined") return { width: 1024, height: 768 };
  return { width: window.innerWidth, height: window.innerHeight };
}

export function useResponsive() {
  const [{ width, height }, setDims] = useState(getDims);
  const [phoneMq, setPhoneMq] = useState(() => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(max-width: 600px)").matches : false));

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => setDims(getDims());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    const mq = window.matchMedia ? window.matchMedia("(max-width: 600px)") : null;
    const onMq = (e) => { setPhoneMq(e.matches); setDims(getDims()); };
    if (mq) { if (mq.addEventListener) mq.addEventListener("change", onMq); else mq.addListener(onMq); }
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
      if (mq) { if (mq.removeEventListener) mq.removeEventListener("change", onMq); else mq.removeListener(onMq); }
    };
  }, []);

  let breakpoint = "mobile";
  if (width >= 1024) breakpoint = "desktop";
  else if (width >= 768) breakpoint = "tablet";

  const isMobile = breakpoint === "mobile";
  const isPhone = phoneMq || width <= 600;
  const isTablet = breakpoint === "tablet";
  const isDesktop = breakpoint === "desktop";

  const readingMaxWidth = isDesktop ? 780 : isTablet ? 700 : width;
  const contentMaxWidth = isDesktop ? 1080 : isTablet ? 900 : width;
  const gridColumns = isDesktop ? 4 : isTablet ? 3 : 2;
  const gutter = isDesktop ? 32 : isTablet ? 24 : 16;

  return {
    width,
    height,
    breakpoint,
    isWeb: true,
    isMobile,
    isPhone,
    isTablet,
    isDesktop,
    readingMaxWidth,
    contentMaxWidth,
    gridColumns,
    gutter,
  };
}

export const BREAKPOINTS = { MOBILE_MAX, TABLET_MAX };
